<template>
    <div class="signup">
        <v-container fluid class="">
            <v-row class="" justify="center">
                <v-col sm="12" md="7" class="my-10 ">
                    <v-card position="center" class="ma-5">
                        <v-row justify="center">
                            <v-card-title class="mt-5 info--text">Register</v-card-title>
                        </v-row>
                        <v-row justify="center">
                            <v-col class="mx-8">
                                <form>
                                    <v-text-field
                                    v-model="name"
                                    :error-messages="nameErrors"
                                    :counter="20"
                                    label="Name"
                                    required
                                    @input="$v.name.$touch()"
                                    @blur="$v.name.$touch()"
                                    ></v-text-field>

                                    <v-text-field
                                    v-model="email"
                                    :rules="[rules.containdomain]"
                                    :error-messages="emailErrors"
                                    label="Email"
                                    required
                                    @input="$v.email.$touch()"
                                    @blur="$v.email.$touch()"
                                    ></v-text-field>

                                    <v-text-field
                                    v-model="password"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                    :error-messages="passwordErrors"
                                    label="Password"
                                    required
                                    @input="$v.password.$touch()"
                                    @blur="$v.password.$touch()"
                                    :type="show1 ? 'text' : 'password'"
                                    @click:append="show1 = !show1"
                                    ></v-text-field>
                                    <v-text-field
                                    v-model="repeatpassword"
                                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                    :error-messages="repeatpasswordErrors"
                                    label="Repeat Password"
                                    required
                                    @input="$v.repeatpassword.$touch()"
                                    @blur="$v.repeatpassword.$touch()"
                                    :type="show2 ? 'text' : 'password'"
                                    @click:append="show2 = !show2"
                                    ></v-text-field>

                                    <p class="red--text center" v-if="feedback">{{feedback}}</p>

                                    <v-row class="ma-5" justify="center">
                                        <v-btn
                                        color="primary"
                                        class="mr-4 info--text"
                                        @click="submit"
                                        width="120"
                                        small
                                        >
                                        Signup
                                        </v-btn>
                                        
                                        <v-btn
                                        color="error"
                                        class="mr-4"
                                        @click="clear"
                                        width="120"
                                        small
                                        text
                                        >
                                        Clear Form
                                        </v-btn>
                                    </v-row>
                                    <p class="red--text" v-if="successsignup">{{successsignup}}</p>
                                </form>
                            </v-col>
                        </v-row>
                        <v-row justify="center" align="center" class="pb-5">
                            <p class="info--text mx-3">or</p>
                            <v-btn small @click="push2login">Login</v-btn>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
/* eslint-disable no-console */
import { validationMixin } from 'vuelidate'
import { required, maxLength, email, minLength, sameAs } from 'vuelidate/lib/validators'
import {db,auth} from '@/fb'

export default {
    name: 'Signup',
    mixins: [validationMixin],

    validations: {
      name: { required, maxLength: maxLength(20) },
      email: { required, email },
      password: {
        required,
        minLength: minLength(6)
      },
      repeatpassword: {
        sameAsPassword: sameAs('password')
      }
    },
    data(){
        return {
            name:'',
            email:'',
            password:'',
            repeatpassword:'',
            submitStatus: null,
            show1:false,
            show2:false,
            feedback:null,
            successsignup:null,
            rules: {
                containdomain: value => value.includes('TPO') || value.includes('tpo') || 'Please use TPO account.',
            },
        }
    },
    computed: {
        nameErrors () {
            const errors = []
            if (!this.$v.name.$dirty) return errors
            !this.$v.name.maxLength && errors.push('Name must be at most 20 characters long')
            !this.$v.name.required && errors.push('Name is required.')
            return errors
        },
        emailErrors () {
            const errors = []
            if (!this.$v.email.$dirty) return errors
            !this.$v.email.email && errors.push('Must be valid e-mail')
            !this.$v.email.required && errors.push('E-mail is required')
            return errors
        },
        passwordErrors () {
            const errors = []
            if (!this.$v.password.$dirty) return errors
            !this.$v.password.required && errors.push('Password is required')
            !this.$v.password.minLength && errors.push('Password be at most 6 characters long')
            return errors
        },
        repeatpasswordErrors () {
            const errors = []
            if (!this.$v.repeatpassword.$dirty) return errors
            !this.$v.repeatpassword.sameAsPassword && errors.push('Password must match!')
            return errors
        },
    },
    methods:{
        submit () {
            if(!this.email.includes('tpo') && !this.email.includes('TPO')){
                this.feedback = "Please contact YourConcierge Team for more information"
            }
            else{
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.feedback = 'ERROR'
                }
                else {
                    // do your submit logic here
                    let ref = db.collection('users')
                    auth.createUserWithEmailAndPassword(this.email,this.password)
                    .then(cred=>{
                        if(cred.user && cred.user.emailVerified === false){
                            cred.user.sendEmailVerification().then(function(){
                                /* eslint-disable no-console */
                                console.log("email verification sent to user");
                                /* eslint-enable no-console */
                            });
                        }
                        ref.doc(cred.user.uid).add({
                            email:cred.user.email,
                            name:this.name
                        })
                        .then(()=>{
                            this.$router.push({name:'dashboard'})
                        })
                        .catch(error=>{
                            /* eslint-disable no-console */
                            console.log(error)
                            /* eslint-enable no-console */
                        })
                        this.successsignup = "Successfully registered!"
                    })
                    .catch(error => {
                        /* eslint-disable no-console */
                        console.log(error)
                        /* eslint-enable no-console */
                        this.feedback = error.message
                    })
                }
            }
        },
        clear () {
            this.$v.$reset()
            this.name = ''
            this.email = ''
            this.password = ''
            this.repeatpassword = ''
        },
        push2login (){
            this.$router.push({name:'login'})
        }
    }
}
</script>

